import EdButton from "../../../../components/generic/edbutton/edButton";
import React from "react";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
export const Sellstock = (props) => {
    var _a;
    const quotesDetailsEntity = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuote.quotesDetailsEntity);
    const rmsHoldingData = useSelector((state) => state.TOCJourney.rmsDetails.rmsHolding);
    const proceedToAuth = () => {
        if (rmsHoldingData &&
            !(rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.authorize) &&
            (rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.sts) === "Ok")
            props.setProceedToAuthorize(true);
    };
    return (React.createElement("div", { className: "sell-stock-block w-100" },
        React.createElement(Row, { className: "DMSanM_14_500 txt_blackOne1 m-0" },
            "Tap on \u2018Proceed\u2019 to authorize Edelweiss to sell",
            " ",
            quotesDetailsEntity && ((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.dpName)),
        React.createElement(Row, { className: "m-0 buttons-block" },
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Sell for Intraday", type: "submit", className: "DMSanM_14_500" }),
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Proceed", type: "submit", className: "DMSanM_14_500", onClick: () => proceedToAuth() }))));
};
